import React from 'react';
import RegistrationForm from "../Includes/RegistrationForm";
import Service from "../Includes/Service";
import Experts from "../Includes/Experts";
import HomeAbout from "../Includes/HomeAbout";
import Testimonial from "../Includes/Testimonial";
import Blog from "../Includes/Blog";
import Map from "../Includes/Map";
import Slider from "../Includes/Slider";
import {Helmet} from "react-helmet";

const Home = () => {
    return (
        <>
            <Helmet>
                <title>Welcome | Mega Dumpster Bin Rental - Best Company That Lets You Clean & Remove Trash & Rubbish</title>
            </Helmet>
            <Slider/>
            <RegistrationForm/>
            <Service/>
            <Experts/>
            <HomeAbout/>
            <Testimonial/>
            <Blog/>
            <Map/>
        </>
    );
};

export default Home;
